module.exports = __webpack_public_path__ + "static/media/Logo_GIFE_azul.a52e8d32.png";